import React from 'react';
import { CapsAuthProvider, useCapsAuth } from '../../context/CapsAuthContext';
import { CommunityLanding } from '../community/CommunityLanding';
import { CommunityDashboard } from '../community/CommunityDashboard';
import { COMMUNITY_BRANDS } from '../community/communityBrands';

const brand = COMMUNITY_BRANDS.caps;

const CapsPageInner = () => {
  const { member, loading } = useCapsAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-[#0E4D2A] flex items-center justify-center text-[#A8B4A6] font-sans tracking-widest text-sm">
        ...
      </div>
    );
  }

  return member ? (
    <CommunityDashboard brand={brand} useAuth={useCapsAuth} forumPath="/caps/forum" />
  ) : (
    <CommunityLanding brand={brand} useAuth={useCapsAuth} />
  );
};

export const CapsPage = () => (
  <CapsAuthProvider>
    <CapsPageInner />
  </CapsAuthProvider>
);

export default CapsPage;
